// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xdpfH","left":"styles_left__Hi2bB","desktopActions":"styles_desktopActions__1gQY2","title":"styles_title__1T5zQ"};